export default "/images/vendor/flag-icon-css/flags/4x3/sv.svg?2b995d455aa93dcba0cf337edbfea357";